<template>
  <v-flex>
    <v-card-title>
      <v-tooltip
        top
        dark
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="warning"
            class="mt-3"
            fab
            dark
            @click.stop="triggerJeaDialog = true;"
            v-on="on"
          >
            <v-icon>not_started</v-icon>
          </v-btn>
        </template>
        <span>Trigger JEA 2020 Creation</span>
      </v-tooltip>
      <v-tooltip
        top
        dark
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="success"
            class="mt-3"
            fab
            dark
            @click.stop="() => showApproveDialog('')"
            v-on="on"
          >
            <v-icon>gpp_good</v-icon>
          </v-btn>
        </template>
        <span>Approve All</span>
      </v-tooltip>
      <v-spacer />
      <v-select
        v-model="filterByStatus"
        :items="filterStatuses()"
        label="Filter By Status"
        item-key="id"
        item-text="name"
        item-value="id"
        class="mt-2"
        style="max-width: 300px;"
        @change="onRefresh"
      />
      <v-flex
        xs12
        md12
      >
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Filter"
          style="float: right; margin-top: 20px; width: 300px;"
        />
      </v-flex>
    </v-card-title>

    <v-tooltip
      top
      dark
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="secondary"
          fab
          dark
          absolute
          top
          left
          @click.stop="onRefresh"
          v-on="on"
        >
          <v-icon>refresh</v-icon>
        </v-btn>
      </template>
      <span>Refresh</span>
    </v-tooltip>

    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :pagination.sync="pagination"
      :loading="isLoading"
      loading-text="Loading..."
      disable-initial-sort
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <tr
          @click="toggleSelected(props.item)"
        >
          <td>
            {{ props.item.id }}
          </td>
          <td>
            {{ props.item.document_type }}
          </td>
          <td>
            {{ props.item.user_id }}
          </td>
          <td>
            {{ props.item.subinvestor_id }}
          </td>
          <td>
            {{ props.item.service_status }}
          </td>
          <td>
            <DateDisplay
              :date="props.item.created_at"
            />
          </td>
          <td class="text-xs">
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  flat
                  icon
                  color="secondary"
                  v-on="on"
                  @click.stop="() => showApproveDialog(props.item.user_id)"
                >
                  <v-icon>request_quote</v-icon>
                </v-btn>
              </template>
              <span>Approve</span>
            </v-tooltip>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  flat
                  icon
                  color="primary"
                  v-on="on"
                  @click.stop="() => downloadPdf(props.item.id)"
                >
                  <v-icon>download</v-icon>
                </v-btn>
              </template>
              <span>Download PDF</span>
            </v-tooltip>
          </td>
        </tr>
        <tr v-if="props.item.id && selected === props.item.id">
          <td colspan="11">
            <JeaUserDetails
              :item="props.item"
            />
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-snackbar
      v-model="snackbarShow"
      :color="snackbarColor"
      :auto-height="true"
    >
      <ul v-if="snackbarErrors">
        <li
          v-for="snackbarError in snackbarErrors"
          :key="snackbarError.message"
        >
          {{ snackbarError.message }}
        </li>
      </ul>

      <div
        v-if="snackbarMessage"
      >
        {{ snackbarMessage }}
      </div>

      <v-btn
        color="primary"
        text
        @click="snackbarShow = false"
      >
        Close
      </v-btn>
    </v-snackbar>

    <TriggerJeaDialog
      :visible="triggerJeaDialog"
      @close="triggerJeaDialog = false;"
      @success="onTriggerJeaSuccess"
    />

    <ApproveJeaDialog
      ref="approveComponent"
      :visible="approveJeaDialog"
      @close="approveJeaDialog = false;"
      @success="onApproveJeaSuccess"
    />
  </v-flex>
</template>

<script>

import TriggerJeaDialog from '@/components/payoutsAndTaxes/payout/dialogs/jea/TriggerJeaDialog';
import ApproveJeaDialog from '@/components/payoutsAndTaxes/payout/dialogs/jea/ApproveJeaDialog';
import JeaUserDetails from '@/components/payoutsAndTaxes/payout/shared/JeaUserDetails';
import DateDisplay from '@/components/payoutsAndTaxes/payout/shared/DateDisplay';
import { base64toBlob, saveFile } from '@/helpers';

export default {
  name: 'JEA2020',
  components: {
    ApproveJeaDialog,
    TriggerJeaDialog,
    JeaUserDetails,
    DateDisplay,
  },
  data() {
    return {
      filterByStatus: 'open',
      selected: 0,
      triggerJeaDialog: false,
      approveJeaDialog: false,
      isLoading: false,
      pagination: {
        rowsPerPage: 25,
      },
      snackbarShow: false,
      snackbarMessage: '',
      snackbarColor: 'error',
      snackbarErrors: [],
      search: '',
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Document Type', value: 'document_type' },
        { text: 'User ID', value: 'user_id' },
        { text: 'Sub Investor ID', value: 'subinvestor_id' },
        { text: 'Service Status', value: 'service_status' },
        { text: 'Created At', value: 'created_at' },
        { text: 'Actions', value: 'actions' },
      ],
    };
  },
  computed: {
    items() {
      return this.$store.getters.getJea2020List;
    },
    filteredItems() {
      const { search } = this;

      if (search.length < 1) {
        return this.items;
      }

      return this.items.filter((item) => {
        let found = false;
        Object.keys(item)
          .map((key) => {
            if (item[key] && String(item[key]).toLowerCase().indexOf(search.toLowerCase()) > -1) {
              found = true;
            }

            return key;
          });

        return found;
      });
    },
  },
  mounted() {
    this.$store.dispatch('fetchPayoutCreationTypes');

    this.onRefresh();
  },
  methods: {
    onRefresh() {
      this.$store.dispatch('fetchJea2020All', this.filterByStatus);
    },
    filterStatuses() {
      return this.statuses();
    },
    statuses() {
      const data = this.$store.getters.getPayoutsCreationTypes;

      if (!data || !data.jea || !data.jea.statuses) {
        return [];
      }

      return this.transformEnumToSelectArray(data.jea.statuses);
    },
    transformEnumToSelectArray(options) {
      const newOptions = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(options)) {
        newOptions.push({
          id: key,
          name: value,
        });
      }

      return newOptions;
    },
    onTriggerJeaSuccess(data) {
      this.triggerJeaDialog = false;

      this.snackbarShow = true;
      this.snackbarErrors = [];
      // eslint-disable-next-line max-len
      this.snackbarMessage = `${data.message} | Payouts: ${data.countPayouts} | User IDs: ${data.countUserIds} | JEA Triggered: ${data.countJeaTriggered}`;
      this.snackbarColor = data.countJeaTriggered > 0 ? 'success' : 'error';
      this.onRefresh();
    },
    onApproveJeaSuccess(data) {
      this.approveJeaDialog = false;

      this.snackbarShow = true;
      this.snackbarErrors = [];
      this.snackbarMessage = `${data.message} | Approved: ${data.countApproved}`;
      this.snackbarColor = data.countApproved > 0 ? 'success' : 'error';
      this.onRefresh();
    },
    toggleSelected(item) {
      this.selected = this.selected === item.id ? null : item.id;
    },
    showApproveDialog(userId) {
      this.$refs.approveComponent.setUserId(userId);
      this.approveJeaDialog = true;
    },
    downloadPdf(id) {
      const data = {
        id,
      };

      this.$store
        .dispatch('fetchJea2020DownloadPdf', data)
        .then((response) => {
          saveFile(base64toBlob(response.data), `${response.headers['x-file-name']}.pdf`);
        });
    },
  },
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/JEA2020.vue